var SettingsIconButtonModule = /** @class */ (function () {
    function SettingsIconButtonModule() {
    }
    return SettingsIconButtonModule;
}());
export { SettingsIconButtonModule };
